module.exports = __webpack_public_path__ + "img/cloud12.9fd265d1.png";